import React from "react";
import {
  List,
  DateField,
  TextField,
  BooleanField,
  DatagridConfigurable,
  FunctionField,
  ReferenceField,
  useGetList,
  Filter,
  BooleanInput,
  AutocompleteInput,
  WrapperField,
  DateInput,
  ReferenceInput,
} from "react-admin";
import ProviderFilter from "../providers/ProviderFilter";

const AppointmentFilter = (props) => {
  const { data: allTypes, isLoading } = useGetList(
    "admin/medical/appointment-types"
  );
  return (
    <Filter {...props}>
      <DateInput
        source="appointment_date_after"
        name="minDate"
        label="Appointments After"
      />
      <DateInput
        source="appointment_date_before"
        name="maxDate"
        label="Appointments Before"
      />
      <BooleanInput source="checked_in" label="Checked-in" name="checked_in" />
      <AutocompleteInput
        label="Appointment type"
        name="appointment_type_id"
        source="appointmentType"
        choices={allTypes}
        optionText={(type) => `${type.category} ${type.name}`}
        isLoading={isLoading}
        sx={{ minWidth: 300 }}
      />
      <ProviderFilter label="Provider" sx={{ minWidth: 300 }} />
      {/*<AutocompleteInput*/}
      {/*    label="Provider"*/}
      {/*    name="provider_id"*/}
      {/*    source="providers"*/}
      {/*    choices={allProviders}*/}
      {/*    optionText={provider => `${provider.user.first_name} ${provider.user.last_name}`}*/}
      {/*    isLoading={isProvidersLoading}*/}
      {/*    sx={{minWidth: 300}}*/}
      {/*/>*/}
      <ReferenceInput
        reference="admin/user"
        source="user_id"
        label="User"
        name="user_id"
        sx={{ minWidth: 300 }}
      />
    </Filter>
  );
};

const renderType = (appointment) => (
  <WrapperField
    sx={{ color: appointment["acuityAppointmentType.color"] }}
    title="appointment.type"
  >
    <TextField source="acuityAppointmentType.category" />/
    <TextField source="acuityAppointmentType.name" />
  </WrapperField>
);

export const AppointmentList = () => {
  return (
    <List
      title="Appointments"
      sort={{ field: "updated_at", order: "DESC" }}
      filters={<AppointmentFilter />}
    >
      <DatagridConfigurable rowClick={false}>
        <TextField source="id" />
        <DateField source="appointmentDate" showTime={true} />
        <FunctionField label="Type" source="type" render={renderType} />
        <BooleanField source="checkedIn" label="Checked-in" sortable={true} />
        <ReferenceField
          source="userId"
          reference="admin/user"
          label="User"
          link="view"
        />
        <ReferenceField
          source="providerId"
          reference="admin/providers"
          label="Provider"
          link="view"
        />
        <DateField source="datetimeCreated" label="Created" />
      </DatagridConfigurable>
    </List>
  );
};
